"use client"

import { useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"

/**
 * Helper hook to manage a modal open state based on a query param.
 */
export default function useIsModalOpen(openParam: string) {
  const searchParams = useSearchParams()
  const searchParamsString = searchParams?.toString()

  const [isOpen, setIsOpen] = useState(false)

  // Check URL params on mount and when URL changes
  useEffect(() => {
    const checkUrlParams = () => {
      const params = new URLSearchParams(window.location.search)
      setIsOpen(!!params.get(openParam))
    }

    // Check initially
    checkUrlParams()

    // Listen for popstate events (back/forward navigation)
    window.addEventListener("popstate", checkUrlParams)
    return () => window.removeEventListener("popstate", checkUrlParams)
  }, [searchParamsString])

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      // On dismiss, remove the query param
      const params = new URLSearchParams(window.location.search)
      params.delete(openParam)

      // Update URL without refreshing the page
      const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}`
      window.history.pushState({}, "", newUrl)

      setIsOpen(false)
    }
  }

  return { isOpen, handleOpenChange }
}
